// removed by extract-text-webpack-plugin
module.exports = {"cardComponentContainer":"cardComponentContainer__3pIf2","cardImage":"cardImage__2-ath","cardHeader":"cardHeader__1-6Pw","cardContent":"cardContent__3grmD"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-fast-feature/components/whyCardlessEmi/cardComponent/style.css
// module id = Fwq3
// module chunks = 380